// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"822d6861","419":"46205c46"}[chunkId] + ".chunk.js";
};